import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFolder, faChevronDown, faTrash, faCopy } from '@fortawesome/free-solid-svg-icons'
import { SortableHandle } from 'react-sortable-hoc';
import _indexOf from 'lodash/indexOf';
import { selectObject, deleteObject, copyObject } from "../actions";
import uuidv4 from 'uuid/v4';

const DragHandle = SortableHandle(() => <span className="layer-sort" />);

class LayerItemText extends Component {
  render() {
    return (
      <div className="t-component-layer-item-text">
        <DragHandle/>
        <div className="layer-icon"><img src={window.tProjectGlobals.assetBaseUrl + "img/tab-sticker-icon.png"} alt=""/></div>
        <div className="layer-body">
          <div className="layer-content">{this.props.data.props.text}</div>
          <div className="layer-type">テキスト</div>
        </div>
        <div className="layer-buttons">
          <button onClick={this.props.onDelete}><FontAwesomeIcon icon={faTrash}/> 削除</button>
          <button onClick={this.props.onCopy}><FontAwesomeIcon icon={faCopy}/> 複製</button>
        </div>
      </div>
    );
  }
}

class LayerItemImage extends Component {
  render() {
    return (
      <div className="t-component-layer-item-image">
        <DragHandle/>
        <div className="layer-icon" style={{backgroundImage: "url(" + this.props.data.src + ")"}}/>
        <div className="layer-body">
          <div className="layer-content">{this.props.data.name}</div>
          <div className="layer-type">画像</div>
        </div>
        <div className="layer-buttons">
          <button onClick={this.props.onDelete}><FontAwesomeIcon icon={faTrash}/> 削除</button>
          <button onClick={this.props.onCopy}><FontAwesomeIcon icon={faCopy}/> 複製</button>
        </div>
      </div>
    );
  }
}

class LayerItemSticker extends Component {
  render() {
    return (
      <div className="t-component-layer-item-image">
        <DragHandle/>
        <div className="layer-icon" style={{backgroundImage: "url(" + this.props.data.src + ")"}}/>
        <div className="layer-body">
          <div className="layer-content">{this.props.data.name}</div>
          <div className="layer-type">スタンプ</div>
        </div>
        <div className="layer-buttons">
          <button onClick={this.props.onDelete}><FontAwesomeIcon icon={faTrash}/> 削除</button>
          <button onClick={this.props.onCopy}><FontAwesomeIcon icon={faCopy}/> 複製</button>
        </div>
      </div>
    );
  }
}

class LayerItemGroup extends Component {
  render() {
    return (
      <div className="t-component-layer-item-group">
        <DragHandle/>
        <div className="layer-icon"><FontAwesomeIcon icon={faFolder} /></div>
        <div className="layer-body">
          <div className="layer-toggle-group"><FontAwesomeIcon icon={faChevronDown}/></div>
        </div>
      </div>
    );
  }
}

class LayerItem extends Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.handleCopy = this.handleCopy.bind(this);
  }

  handleCopy(e) {
    this.props.copyObject(this.props.data, uuidv4());
    e.preventDefault();
    e.stopPropagation();
  }

  handleDelete(e) {
    this.props.deleteObject([this.props.data.id]);
    e.preventDefault();
    e.stopPropagation();
  }

  render() {
    switch (this.props.data.type) {
      case "text":
        return this.wrap(<LayerItemText data={this.props.data} onDelete={this.handleDelete} onCopy={this.handleCopy} />);
      case 'image':
        return this.wrap(<LayerItemImage data={this.props.data} onDelete={this.handleDelete} onCopy={this.handleCopy}/>);
      case 'sticker':
        return this.wrap(<LayerItemSticker data={this.props.data} onDelete={this.handleDelete} onCopy={this.handleCopy}/>);
      case 'group':
        return this.wrap(<LayerItemGroup data={this.props.data} onDelete={this.handleDelete} onCopy={this.handleCopy}/>);
      default:
        return null;
    }
  }

  handleClick(e) {
    this.props.selectObject(this.props.data, {});
    e.preventDefault();
  }

  wrap(element) {
    const isSelected = _indexOf(this.props.layers.selected, this.props.data.id) !== -1;
    const className = 't-component-layer-item clearfix ' + (isSelected ? 'active' : '');

    return (
      <div className={className} onClick={this.handleClick}>
        {element}
      </div>
    );
  }
}

export default connect(f => f, {selectObject, deleteObject, copyObject})(LayerItem);



// WEBPACK FOOTER //
// ./src/components/LayerItem.js